import { BaseController } from '../../../base/controller';

export class TicketNotesController extends BaseController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    if (!this.newNote) {
      this.newNote = {};
    }
    this.isSending = false;
  }

  createNewNote() {
    const { text } = this.newNote;

    if (this.isCreateNewBusy || !text) {
      // Prevents submitting an empty string or resubmit
      return;
    }

    this.ticketService
      .addComment(this.ticketId, { text }, this.$stateParams.product)
      .busy(this, 'isCreateNewBusy')
      .then(() => (this.newNote = {}));
  }
}
